// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"604":"af5cb70a","911":"70563f94"}[chunkId] + ".chunk.js";
};